import { Component } from '@angular/core';
import { AppConstants } from '@core/constants/app';
import { ApplicationConfigService } from '@core/data/application-config.service';
import * as moment from 'moment/moment';
import { catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { Location } from '@angular/common';
import { Generic } from '@core/interfaces/entities/generic';

@Component({
  selector: 'app-medicare-application',
  templateUrl: './medicare-application.component.html',
  styleUrls: ['./medicare-application.component.scss'],
})
export class MedicareApplicationComponent {

  public steps = AppConstants.getStepsMapping();
  public materialId: '';
  private applicationIdAttr = null;


  get applicationId(): string | null {
    return this.applicationIdAttr;
  }
  set applicationId(value: string) {
    this.applicationIdAttr = value;
  }
  constructor(private applicationConfigService: ApplicationConfigService,
              private location: Location) {
    const stateParam: Generic = this.location.getState();
    this.applicationConfigService.getConfig().pipe(
      take(1),
      catchError(() => of(null))
    ).subscribe(data => {
      if (data?.requestedEffectiveDate && moment(data?.requestedEffectiveDate, 'YYYY-MM-DD').isValid()) {
        this.materialId = AppConstants.APPLICATION_MATERIAL_IDS[moment(data.requestedEffectiveDate, 'YYYY-MM-DD').year()];
      }
      else{
        this.materialId = AppConstants.APPLICATION_MATERIAL_IDS[moment(stateParam?.requestedEffectiveDate, 'YYYY-MM-DD').year()];
      }
      if (data.applicationId) {
        this.applicationId = data.applicationId;
      }
    });
  }
}
